import React from 'react'

function Zodvia() {


    const styles = {
    background: 'linear-gradient(to right, #2d0037, #4b005f)',
    minHeight: '100vh',
    padding: '2rem 1rem',
    color: '#fff',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const card = {
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    borderRadius: '12px',
    padding: '2rem',
    maxWidth: '900px',
    width: '100%',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
    overflowY: 'auto'
  };

  const heading = {
    color: '#ffd86b',
    marginBottom: '1rem'
  };

  const sectionTitle = {
    color: '#ff94d0',
    marginTop: '1.5rem'
  };

  const linkStyle = {
    color: '#ffd86b',
    textDecoration: 'underline'
  };

  return (
    <div style={styles}>
      <div style={card}>
        <h1 style={heading}>Política de Privacidad de Zodvia</h1>
        <p><strong>Última actualización:</strong> 17 de octubre de 2025</p>

        <p>
          Zodvia valora y respeta tu privacidad. Esta Política de Privacidad explica cómo recopilamos, utilizamos, almacenamos y protegemos tus datos personales cuando utilizas nuestra aplicación móvil, disponible en Google Play Store.
        </p>

        <h2 style={sectionTitle}>1. Información que recopilamos</h2>
        <p>Para ofrecer una experiencia personalizada de lectura de tarot, Zodvia puede recopilar la siguiente información:</p>
        <ul>
          <li><strong>Nombre</strong> (proporcionado por el usuario)</li>
          <li><strong>Fecha de nacimiento</strong> (proporcionada por el usuario)</li>
        </ul>
        <p>Esta información se utiliza exclusivamente para generar una lectura personalizada dentro de la app y no se comparte con terceros.</p>

        <h2 style={sectionTitle}>2. Uso de la información</h2>
        <ul>
          <li>Proporcionar lecturas de tarot personalizadas a través del chat integrado.</li>
          <li>Mejorar la experiencia del usuario dentro de la aplicación.</li>
          <li>Personalizar el contenido según los datos proporcionados.</li>
        </ul>
        <p>Zodvia no utiliza tus datos personales para fines publicitarios ni los vende a terceros.</p>

        <h2 style={sectionTitle}>3. Almacenamiento y seguridad de los datos</h2>
        <p>Todos los datos proporcionados se procesan de forma segura con medidas adecuadas para protegerlos de accesos no autorizados.</p>

        <h2 style={sectionTitle}>4. Compartición de la información</h2>
        <p>Zodvia no comparte tus datos personales con terceros, salvo en los siguientes casos:</p>
        <ul>
          <li>Cuando sea requerido por ley.</li>
          <li>Si usamos servicios de terceros que cumplen con políticas de privacidad estrictas.</li>
        </ul>

        <h2 style={sectionTitle}>5. Derechos del usuario</h2>
        <p>Como usuario, tienes derecho a:</p>
        <ul>
          <li>Acceder a tus datos personales.</li>
          <li>Solicitar su corrección o eliminación.</li>
          <li>Retirar tu consentimiento en cualquier momento.</li>
        </ul>
        <p>Para ejercer tus derechos, contáctanos: <a href="mailto:zodvia2025@gmail.com" style={linkStyle}>zodvia2025@gmail.com</a></p>

        <h2 style={sectionTitle}>6. Consentimiento del usuario</h2>
        <p>
          Al utilizar la app Zodvia y proporcionar tus datos personales, confirmas que has leído y aceptado esta Política de Privacidad.
        </p>

        <h2 style={sectionTitle}>7. Menores de edad</h2>
        <p>
          Zodvia no está destinada a menores de 13 años. Si crees que un menor nos ha proporcionado datos, contáctanos para eliminarlos.
        </p>

        <h2 style={sectionTitle}>8. Cambios en la Política de Privacidad</h2>
        <p>
          Esta política puede modificarse en cualquier momento. Notificaremos los cambios mediante esta página o dentro de la app.
        </p>

        <h2 style={sectionTitle}>9. Contacto</h2>
        <p>
          Si tienes preguntas sobre esta política, contáctanos en:
          <br />
          📧 <a href="mailto:zodvia2025@gmail.com" style={linkStyle}>zodvia2025@gmail.com</a>
        </p>

        <p style={{ marginTop: '2rem', fontStyle: 'italic', color: '#ccc' }}>
          Esta Política de Privacidad cumple con las políticas de Google Play y la normativa de protección de datos aplicable.
        </p>
      </div>
    </div>
  )
}

export default Zodvia
